function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import { colors, spacing } from '../tokens';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function LoadingSpinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var sizePixels = {
    sm: '16px',
    md: '32px',
    lg: '48px',
    xl: '64px'
  };
  var spinnerStyle = {
    width: sizePixels[size] || sizePixels.md,
    height: sizePixels[size] || sizePixels.md,
    border: "3px solid ".concat(colors.neutral[200]),
    borderTop: "3px solid ".concat(colors.primary[600]),
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
    display: 'inline-block'
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: spacing.md
    },
    className: className,
    children: [/*#__PURE__*/_jsx("style", {
      children: "@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }"
    }), /*#__PURE__*/_jsx("div", {
      style: spinnerStyle
    })]
  });
}
export function ErrorMessage(_ref2) {
  var message = _ref2.message,
    onRetry = _ref2.onRetry,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className;
  if (!message) return null;
  var boxStyle = {
    backgroundColor: colors.danger[50],
    borderLeft: "4px solid ".concat(colors.danger[500]),
    padding: spacing.md,
    borderRadius: '6px',
    margin: "".concat(spacing.md, " 0")
  };
  return /*#__PURE__*/_jsxs("div", {
    style: boxStyle,
    className: className,
    children: [/*#__PURE__*/_jsx("p", {
      style: {
        margin: 0,
        color: colors.danger[700],
        fontWeight: 500
      },
      children: message
    }), onRetry && /*#__PURE__*/_jsx("button", {
      onClick: onRetry,
      style: {
        marginTop: spacing.xs,
        background: 'none',
        border: 'none',
        color: colors.danger[700],
        textDecoration: 'underline',
        cursor: 'pointer',
        fontWeight: 600
      },
      children: "Try again"
    })]
  });
}
export var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _callSuper(this, ErrorBoundary, [props]);
    _this.state = {
      hasError: false,
      error: null
    };
    return _this;
  }
  _inherits(ErrorBoundary, _React$Component);
  return _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      console.error('ErrorBoundary caught an error', error, errorInfo);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.state.hasError) {
        var _this$state$error;
        return /*#__PURE__*/_jsx(ErrorMessage, {
          message: ((_this$state$error = this.state.error) === null || _this$state$error === void 0 ? void 0 : _this$state$error.message) || 'An unexpected application error occurred.',
          onRetry: function onRetry() {
            return _this2.setState({
              hasError: false,
              error: null
            });
          }
        });
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        hasError: true,
        error: error
      };
    }
  }]);
}(React.Component);